import React, { useState } from 'react';
import 'tailwindcss/tailwind.css';

interface Player {
    id: number;
    name: string;
    score: number;
}

const initialPlayers: Player[] = [
    { id: 1, name: 'Player 1', score: 72 },
    { id: 2, name: 'Player 2', score: 68 },
    { id: 3, name: 'Player 3', score: 70 },
];

const Standings: React.FC = () => {
    const [players, setPlayers] = useState<Player[]>(initialPlayers);
    const [editingPlayerId, setEditingPlayerId] = useState<number | null>(null);
    const [newScore, setNewScore] = useState<number | null>(null);

    const handleEditClick = (id: number) => {
        setEditingPlayerId(id);
    };

    const handleSaveClick = (id: number) => {
        if (newScore !== null) {
            setPlayers(players.map(player => player.id === id ? { ...player, score: newScore } : player));
            setEditingPlayerId(null);
            setNewScore(null);
        }
    };

    return (
        <div className="container mx-auto p-4">
            <h1 className="text-2xl font-bold mb-4">Golf League Standings</h1>
            <table className="min-w-full bg-white">
                <thead>
                    <tr>
                        <th className="py-2 px-4 border-b">Player</th>
                        <th className="py-2 px-4 border-b">Score</th>
                        <th className="py-2 px-4 border-b">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {players.map(player => (
                        <tr key={player.id}>
                            <td className="py-2 px-4 border-b">{player.name}</td>
                            <td className="py-2 px-4 border-b">
                                {editingPlayerId === player.id ? (
                                    <input
                                        type="number"
                                        value={newScore !== null ? newScore : player.score}
                                        onChange={(e) => setNewScore(parseInt(e.target.value))}
                                        className="border rounded px-2 py-1"
                                    />
                                ) : (
                                    player.score
                                )}
                            </td>
                            <td className="py-2 px-4 border-b">
                                {editingPlayerId === player.id ? (
                                    <button
                                        onClick={() => handleSaveClick(player.id)}
                                        className="bg-blue-500 text-white px-4 py-2 rounded"
                                    >
                                        Save
                                    </button>
                                ) : (
                                    <button
                                        onClick={() => handleEditClick(player.id)}
                                        className="bg-yellow-500 text-white px-4 py-2 rounded"
                                    >
                                        Edit
                                    </button>
                                )}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default Standings;